import React, { useEffect } from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { useState } from "react";
import { useDispatch } from "react-redux";
import businessData from "../../store/allAddBusinessData";

function Countary() {
  const dispatch = useDispatch();

  const { setBusinessPhone } = businessData.actions;

  const [value, setValue] = useState();

  useEffect(() => {
    dispatch(setBusinessPhone(value));
  }, [value]);

  return (
    <>
      <PhoneInput placeholder="+1490300330" value={value} onChange={setValue} />
    </>
  );
}

export default Countary;
